import { render, staticRenderFns } from "./DashboardPartnerProgramCardSkeleton.vue?vue&type=template&id=d1262b6e&scoped=true"
import script from "./DashboardPartnerProgramCardSkeleton.vue?vue&type=script&lang=ts"
export * from "./DashboardPartnerProgramCardSkeleton.vue?vue&type=script&lang=ts"
import style0 from "./DashboardPartnerProgramCardSkeleton.vue?vue&type=style&index=0&id=d1262b6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1262b6e",
  null
  
)

export default component.exports